import QueryTags from '../../types/QueryTags'
import { OtpRequest, SendOtpNotificationRequest, VerifyOtpNotificationRequest } from './types/request'
import { CurrentUser } from 'types'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'
import { SendOtpNotificationResponse, VerifyOtpNotificationResponse } from './types/response'


const authBasepath = '/auth/v1'
const otpNotifBasepath = '/notification/v1'

const otpEndPoint = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, QueryTags, 'data'>) => 
  ({
    verifyOtp: builder.mutation<CurrentUser, OtpRequest>({
      query: (body) => {
        return(
          {
            url: `${authBasepath}/v2/verify_otp`,
            method: 'POST',
            body
          }
        )
      }
    }),
    verifyOtpV2: builder.mutation<any, OtpRequest>({
      query: (body) => {
        return(
          {
            url: `${otpNotifBasepath}/v2/verify-otp`,
            method: 'POST',
            body,
          }
        )
      },
    }),
    sendOtpNotification: builder.mutation<SendOtpNotificationResponse, SendOtpNotificationRequest>({
      query: (body) => {
        return(
          {
            url: `${otpNotifBasepath}/send-otp`,
            method: 'POST',
            body,
          }
        )
      }
    }),
    verifyOtpNotification: builder.query<VerifyOtpNotificationResponse, VerifyOtpNotificationRequest>({
      query: (args) => {
        return(
          {
            url: `${otpNotifBasepath}/verify-otp`,
            method: 'GET',
            params: args,
          }
        )
      }
    }),
  })


export default otpEndPoint